import { TherapyAttribute } from '@repo/types/src/glow-up';
import { TherapyAttributeCard } from './TherapyAttributeCard';

type TherapyAttributeListProps = {
  attributes: TherapyAttribute[];
  refetch: () => void;
};

export const TherapyAttributeList = ({
  attributes,
  refetch,
}: TherapyAttributeListProps) => {
  if (!attributes.length) {
    return (
      <p className="text-sm text-muted-foreground">
        Aucun attribut de thérapie pour le moment.
      </p>
    );
  }

  return (
    <div className="flex flex-wrap gap-4">
      {attributes.map((attribute) => (
        <TherapyAttributeCard
          key={attribute.id}
          attribute={attribute}
          refetch={refetch}
        />
      ))}
    </div>
  );
};
